/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { CardCreator, MetaData, StyledButton } from '@/components/atoms'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { background_list, icon_list } from '@/assets/images'
import { useRef, useEffect } from 'react'
import { TematicStudioBox, TitlePointDescSection, TitleWantToApply, TitleWantToBeCreator } from '@/components/molecules'
import { getSeoMetadata } from '@/utility/apiProcess/seo/server'

const LiveStreamer = (props) => {
  console.log(props)
	const { t } = useTranslation('livestream')
	const router = useRouter()

  const howAreWeData = {
    title: t('livestream.wbc'),
    description: t('livestream.wbc_desc'),
    points: [
      {
        title: t('livestream.wbc1'),
        description: t('livestream.wbc1_desc')
      },
      {
        title: t('livestream.wbc2'),
        description: t('livestream.wbc2_desc')
      },
      {
        title: t('livestream.wbc3'),
        description: t('livestream.wbc3_desc')
      },
      {
        title: t('livestream.wbc4'),
        description: t('livestream.wbc4_desc')
      },
    ]
  }

  const howToApply = {
    title: t('livestream.why'),
    description: t('livestream.why_desc'),
    points: [
      {
        title: t('livestream.w1'),
        description: t('livestream.w1_desc')
      },
      {
        title: t('livestream.w2'),
        description:t('livestream.w2_desc')
      },
      {
        title: t('livestream.w3'),
        description:t('livestream.w3_desc')
      },
      {
        title: t('livestream.w4'),
        description: t('livestream.w4_desc')
      },
    ]
  }

  const dataCreator =  [
    {
      name: t('livestream.pc1_name'),
      description: t('livestream.pc1_desc'),
      image: background_list.ls1
    },
    {
      name: t('livestream.pc2_name'),
      description: t('livestream.pc2_desc'),
      image: background_list.ls2
    },
    {
      name: t('livestream.pc3_name'),
      description: t('livestream.pc3_desc'),
      image: background_list.ls3
    },
  ]

      
	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 md:tw-px-0 tw-px-4 tw-max-w-6xl tw-mx-auto tw-grid md:tw-grid-cols-2 tw-gap-2'>
					<div className='tw-flex tw-flex-col tw-justify-center'>
            <h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 md:tw-text-left tw-text-center'>
              {t('livestream.title')}
            </h2>
            <span className='tw-text-white tw-text-sm md:tw-text-justify tw-flex tw-text-center'>
              {t('livestream.desc')}
            </span>
            <div className='md:tw-flex tw-hidden tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton
                title={t('livestream.apply')}
                className='tw-text-white tw-mt-5 tw-font-semibold md:tw-text-xl tw-text-xs tw-items-center tw-border-2 tw-border-white md:tw-px-6 tw-px-5 md:tw-py-2 tw-py-3 tw-rounded-full tw-justify-center md:tw-flex'
                onClick={() => router.push(`${route_list.register}?type=partner`)}
              />
            </div>
          </div>
          <div className='tw:w-full tw-flex tw-flex-col tw-items-center tw-justify-center'>
            <Image src={background_list.live_streamer} alt='' className='md:tw-w-[60%] tw-w-[50%]' />
            <div className='md:tw-hidden tw-flex tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton
                title={'Apply now →'}
                className='tw-text-white tw-mt-5 tw-font-semibold md:tw-text-xl tw-text-xs tw-items-center tw-border-2 tw-border-white md:tw-px-6 tw-px-5 md:tw-py-2 tw-py-3 tw-rounded-full tw-justify-center md:tw-flex'
                onClick={() => router.push(`${route_list.register}?type=partner`)}
              />
            </div>
          </div>
				</div>
			</div> 
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px] tw-overflow-hidden'>
				<div className='tw-newsroom-container'>
					<div className='tw-max-w-6xl tw-mx-auto tw-my-8 md:tw-px-0 tw-px-4 tw-text-justify'>
            {/* Social bread content creator */}
            <div className="tw-w-full md:tw-mb-0 tw-rounded-xl">
              <div className=' tw-bg-white tw-p-4 tw-rounded-xl tw-h-full tw-flex tw-flex-col md:tw-items-center'>
                <h2 className="md:tw-text-4xl tw-text-center tw-text-2xl tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-mb-3 tw-w-fit">
                  {t('livestream.sbc')}
                </h2>
                <div className="tw-text-base tw-leading-7 tw-black tw-text-center">
                  {t('livestream.sbc_desc')}
                </div>
              </div>
            </div>
            {/* Why you should join us? */}
            <div className='tw-my-20'>
              <TitlePointDescSection data={howToApply}/>
            </div>
            
            {/* Our Creators */}
            <div className='tw-my-20'>
              <div className='tw-mb-10'>
                <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-3 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-90% tw-text-left tw-w-fit'> {t('livestream.oc')}</h1>
                <div className='tw-text-left'>"{t('livestream.oc_desc')}"</div>
              </div>
              <div className=' tw-flex tw-items-center tw-justify-center'>
                <h1 className='md:tw-text-2xl tw-text-2xl tw-font-semibold tw-mb-3 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-90% tw-text-left tw-w-fit'>POPULAR STREAMERS</h1>
              </div>
              <CardCreator data={dataCreator} images={[background_list.gradient_purple, background_list.gradient_purple_reverse]}/>
            </div>

            {/* Want to be a Content Creator? */}
            <div className='tw-my-16'>
              <TitleWantToApply data={howAreWeData}/>
            </div>

            <div className=' tw-flex tw-justify-center tw-mb-32'>
              <StyledButton
                title={'Apply now →'}
                className='tw-text-white btn-dark-to-light-green-gradient md:tw-text-lg tw-text-xs tw-items-center md:tw-px-14 tw-px-10 md:tw-py-2 tw-py-3 tw-rounded-full tw-justify-center md:tw-flex'
                onClick={() => router.push(`${route_list.register}?type=partner`)}
              />
            </div>
        
					</div>
				</div>
			</div>
		</div>
	)
}

export default LiveStreamer

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'live-streamer'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

  return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'privacy-policy'])),
		},
	}
}
